
        import 'peachy-library.cf8c5ce.css-module'
        export default {"clickable":"clickable_peachy-library_cf8c5ce"}
    